exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/_object-gops.js
// module id = 1kS7
// module chunks = 0